<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-content-wrapper">

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        New/Used Why Buy Message
        <i class="pi pi-info-circle"
           pTooltip="Enter an account-wide ‘Why Buy’ message that highlights key reasons to choose the dealership. This syncs to the Why Buy section on all non-service pages."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea rows="6" class="tall-textarea" formControlName="whyBuyMessage"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Service Why Buy Message
        <i class="pi pi-info-circle"
           pTooltip="Enter a ‘Why Buy’ message tailored for service pages, highlighting reasons to service at the dealership."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea rows="6" class="tall-textarea" formControlName="serviceWhyBuyMessage"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Service Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Text entered here will display at the bottom of all Service Landing Pages. Useful for California requirements or other service compliance messaging."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputTextarea rows="6" class="tall-textarea" formControlName="serviceDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Page Header Main CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Customize the main button text in the header sections of landing pages. By default, this CTA reads ‘Special Offers’."
           tooltipPosition="top"></i>
      </label>
      <input pInputText type="text" formControlName="pagesMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Inventory Main CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Changes the ‘View Inventory’ button text in page header sections."
           tooltipPosition="top"></i>
      </label>
      <input pInputText type="text" formControlName="inventoryMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Used Ads on New VLPs
        <i class="pi pi-info-circle"
           pTooltip="Show Used Ads on New VLPs"
           tooltipPosition="top"></i>
      </label>
      <p-inputSwitch formControlName="newVlpShowUsed"></p-inputSwitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        No Offer Set Lead Form
        <i class="pi pi-info-circle"
           pTooltip="When enabled, a lead form will display if no Offer Sets are available. When disabled, nothing will show."
           tooltipPosition="top"></i>
      </label>
      <p-inputSwitch formControlName="showDefaultForm"></p-inputSwitch>
    </div>
  </div>
</form>
